import { gql } from '@apollo/client';
import { isEmpty, isNil } from 'lodash';

export const mutation = gql`
  mutation TransferSecret(
    $sourceClusterId: uuid!
    $targetClusterId: uuid!
    $sourceSecretId: uuid!
    $targetSecretId: uuid!
    $additionalValues: json
  ) {
    transferSecret: transfer_secret(
      sourceClusterId: $sourceClusterId
      targetClusterId: $targetClusterId
      sourceSecretId: $sourceSecretId
      targetSecretId: $targetSecretId
      additionalValues: $additionalValues
    ) {
      success
      targetSecretId
      targetClusterId
    }
  }
`;

export function buildVariables({ sourceClusterId, targetClusterId, sourceSecretId, targetSecretId, additionalValues }) {
  // Identical secret objects should share universal IDs across clusters, in which case consumers
  // refusing to explicitly provide a `targetClusterId` may help ensure a deterministic outcome
  const resolvedTargetSecretId = isNil(targetSecretId) ? sourceSecretId : targetSecretId;

  // Why: adding values to a secrets object requires a novel secret object in the event other
  // uses of the underlying secret only require the base secret object
  if (!isEmpty(additionalValues) && resolvedTargetSecretId === sourceSecretId) {
    throw new Error(
      'useTransferSecret: targetSecretId must differ from sourceSecretId when additionalValues are provided'
    );
  }

  return {
    sourceClusterId,
    targetClusterId,
    sourceSecretId,
    targetSecretId: resolvedTargetSecretId,
    additionalValues,
  };
}
